var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c(
            "q-uploader",
            _vm._b(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showUploader,
                    expression: "showUploader"
                  }
                ],
                ref: "uploadwidget",
                attrs: {
                  extensions: ".gif,.jpg,.jpeg,.png",
                  url: _vm.fullApiUploadUrl,
                  method: "POST",
                  before: _vm.beforeIcons,
                  "hide-upload-button": !_vm.theModelId
                },
                on: {
                  uploaded: _vm.handleUploadComplete,
                  fail: _vm.handleFail,
                  add: _vm.handleAdd,
                  "remove:abort": _vm.handleRemove,
                  "remove:cancel": _vm.handleRemove
                }
              },
              "q-uploader",
              _vm.componentProps,
              false
            )
          ),
          !!_vm.value
            ? _c(
                "q-btn-group",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !!_vm.value && !_vm.showUploader,
                      expression: "!!value && !showUploader"
                    }
                  ],
                  attrs: { push: "" }
                },
                [
                  _c(
                    "q-btn",
                    {
                      attrs: {
                        color: "primary",
                        push: "",
                        icon: "file download"
                      },
                      on: { click: _vm.handleDownload }
                    },
                    [_c("q-tooltip", [_vm._v("Download File")])],
                    1
                  ),
                  _c(
                    "q-btn",
                    {
                      attrs: {
                        color: "secondary",
                        push: "",
                        icon: "file upload"
                      },
                      on: {
                        click: function($event) {
                          _vm.showUploader = true
                        }
                      }
                    },
                    [_c("q-tooltip", [_vm._v("Upload File")])],
                    1
                  ),
                  _c(
                    "q-btn",
                    {
                      attrs: { color: "negative", push: "", icon: "delete" },
                      on: { click: _vm.handleDelete }
                    },
                    [_c("q-tooltip", [_vm._v("Delete File")])],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "col-6 text-right" }, [
        _vm.value &&
        typeof _vm.value === "string" &&
        _vm.value.startsWith("http")
          ? _c("a", { attrs: { href: _vm.value, target: "_blank" } }, [
              _c("img", {
                staticClass: "flex inline shadow-box flex-center shadow-6",
                staticStyle: { "max-height": "36px", width: "auto" },
                attrs: { src: _vm.value }
              })
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }